export default __webpack_public_path__ + "static/media/jcw.997c4079.gif";